// extracted by mini-css-extract-plugin
export var screen1 = "screen1-module--screen1--8aee9";
export var screen1__container = "screen1-module--screen1__container--ba6c7";
export var screen1__imageWrapper = "screen1-module--screen1__image-wrapper--ca10f";
export var screen1__imgTeacher = "screen1-module--screen1__img-teacher--0b851";
export var screen1__infoCol = "screen1-module--screen1__info-col--84220";
export var screen1__infoColSecond = "screen1-module--screen1__info-col--second--6f3b7";
export var screen1__infoWrapper = "screen1-module--screen1__info-wrapper--dc985";
export var screen1__linkWrapper = "screen1-module--screen1__link-wrapper--5a286";
export var screen1__subtitle = "screen1-module--screen1__subtitle--066ba";
export var screen1__text = "screen1-module--screen1__text--7a8fa";
export var screen1__title = "screen1-module--screen1__title--88ede";
export var screen1__titleWrapper = "screen1-module--screen1__title-wrapper--18130";